module.exports = __webpack_public_path__ + "static/media/info-icon.a21f5b2b.svg";